var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsArrowBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_9332",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 9332",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_3930",
    "data-name": "\\u9577\\u65B9\\u5F62 3930",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1553",
    "data-name": "\\u30D1\\u30B9 1553",
    d: "M9.222,20.444a1.994,1.994,0,0,1-1.414-.586L-2.828,9.222,7.808-1.414a2,2,0,0,1,2.828,0,2,2,0,0,1,0,2.828L2.828,9.222l7.808,7.808a2,2,0,0,1-1.414,3.414Z",
    transform: "translate(2.576 16.611) rotate(-90)",
    fill: "#4ea9cd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsArrowBottom);
export default __webpack_public_path__ + "static/media/icons_arrow_bottom.1517a2a65d19589ae269a0d39dc7105c.svg";
export { ForwardRef as ReactComponent };